import script from "./Website.vue?vue&type=script&setup=true&lang=js"
export * from "./Website.vue?vue&type=script&setup=true&lang=js"

import "./Website.vue?vue&type=style&index=0&id=93c50f48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93c50f48"]])

export default __exports__